import { useApiUserApplicationsRetrieve } from "@/api/lctApIComponents";
import { useAuth } from "@/auth/hooks/useAuth";
import { useAppSelector } from "@/hooks/reduxHooks";
import { ApplicationStatus } from "@/utils/constants";

export const useUserAppInfo = (userAppId?: string) => {
  let isSubmittable = false;
  const { isStaff } = useAuth();

  const token = useAppSelector((state) => state.user.authKey);

  const { data: userApplication, refetch: refetchUserAppData } = useApiUserApplicationsRetrieve(
    {
      headers: { Authorization: `Token ${token}` },
      pathParams: { id: userAppId ?? "" },
    },
    {
      enabled: !!userAppId,
    },
  );

  isSubmittable = userApplication?.is_submissible ?? false;
  const appStatus = userApplication?.status;
  const currentPartFromApi = Number(userApplication?.current_part);
  const currentPart =
    appStatus === ApplicationStatus.PART_1_APPROVED ||
    appStatus === ApplicationStatus.PART_2_SUBMITTED ||
    appStatus === ApplicationStatus.FURTHER_INFO_PART_2 ||
    appStatus === ApplicationStatus.APPROVED ||
    appStatus === ApplicationStatus.REJECTED
      ? 2
      : 1;

  const part1Locked =
    appStatus === ApplicationStatus.PART_1_APPROVED ||
    appStatus === ApplicationStatus.FURTHER_INFO_PART_2 ||
    appStatus === ApplicationStatus.PART_1_SUBMITTED ||
    appStatus === ApplicationStatus.PART_2_SUBMITTED ||
    appStatus === ApplicationStatus.APPROVED ||
    appStatus === ApplicationStatus.REJECTED ||
    currentPart === 2 ||
    isStaff;

  const part2Locked =
    appStatus === ApplicationStatus.STARTED ||
    appStatus === ApplicationStatus.FURTHER_INFO_PART_1 ||
    appStatus === ApplicationStatus.PART_2_SUBMITTED ||
    appStatus === ApplicationStatus.APPROVED ||
    appStatus === ApplicationStatus.REJECTED ||
    isStaff ||
    currentPart === 1;

  const isActionable =
    appStatus == ApplicationStatus.PART_1_SUBMITTED ||
    appStatus == ApplicationStatus.PART_2_SUBMITTED ||
    appStatus == ApplicationStatus.FURTHER_INFO_PART_1 ||
    appStatus == ApplicationStatus.FURTHER_INFO_PART_2;

  const carbonScore = userApplication?.carbon_score;
  const proposedCarbonScore = userApplication?.proposed_carbon_score;
  const showCarbonScore = appStatus === ApplicationStatus.APPROVED || appStatus === ApplicationStatus.REJECTED;

  const userApplicationId = userApplication?.user_app_id;

  const applicationEditable = (currentPart === 1 && !part1Locked) || (currentPart === 2 && !part2Locked);

  return {
    isSubmittable,
    refetchUserAppData,
    appStatus,
    currentPart,
    part1Locked,
    part2Locked,
    isActionable,
    carbonScore,
    userApplicationId,
    applicationEditable,
    userApplication,
    proposedCarbonScore,
    showCarbonScore,
    currentPartFromApi,
  };
};
